const INITIAL_STATE = { invoice_summary: {}}

const invoiceSummaryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'SET_INVOICE_SUMMARY':
    return { ...state, invoice_summary: action.invoice_summary }
  default:
    return { ...state }
  }
};
	
export default invoiceSummaryReducer;